<!-- @format -->

<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
            <div class="card">
                <FlashMessage :position="'right top'"></FlashMessage>

                <div class="card-header">
                    <h4 class="title">Add Product</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="submit" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-md-6">
                                <label>Category<em style="color: red">*</em></label>
                                <select class="form-control" v-model.trim="$v.productdata.categoryid.$model">
                                    <option disabled value>Select category</option>
                                    <option v-for="(list, index) in category" :value="list.categoryid" :key="index">
                                        {{ list.categoryname }}
                                    </option>
                                </select>
                                <div class="error" v-if="submitted && !$v.productdata.categoryid.required">
                                    Please select category
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label>Sub Category<em style="color: red">*</em></label>
                                <select class="form-control" v-model.trim="$v.productdata.subcategoryid.$model">
                                    <option disabled value>Select subcategory</option>
                                    <option v-for="(list, index) in subcategory" :value="list.subcategoryid"
                                        :key="index">
                                        {{ list.subcategoryname }}
                                    </option>
                                </select>
                                <div class="error" v-if="submitted && !$v.productdata.subcategoryid.required">
                                    Please select subcategory
                                </div>
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-md-12">
                                <label>Product<em style="color: red">*</em></label>
                                <input class="form-control" v-model.trim="$v.productdata.productname.$model" type="text"
                                    label="Product" placeholder="Enter product" />
                                <div class="error" v-if="submitted && !$v.productdata.productname.required">
                                    Please enter product
                                </div>
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-md-12">
                                <label>Short Description<em style="color: red">*</em></label>
                                <textarea class="form-control"
                                    v-model.trim="$v.productdata.shortproductdescription.$model"
                                    placeholder="Enter product description"></textarea>
                                <div class="error" v-if="
    submitted &&
    !$v.productdata.shortproductdescription.required
">
                                    Please enter short description
                                </div>
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-md-12">
                                <label>Description<em style="color: red">*</em></label>
                                <ckeditor :editor="editor" v-model="$v.productdata.productdescription.$model">
                                </ckeditor>
                                <div class="error" v-if="
    submitted && !$v.productdata.productdescription.required
">
                                    Please enter product description
                                </div>
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-md-4">
                                <label>SKU<em style="color: red">*</em></label>
                                <input class="form-control" v-model.trim="$v.productdata.sku.$model" type="text"
                                    label="SKU" placeholder="Enter SKU" />
                                <div class="error" v-if="submitted && !$v.productdata.sku.required">
                                    Please enter SKU
                                </div>
                            </div>

                            <div class="col-md-4">
                                <label>Price<em style="color: red">*</em></label>
                                <input class="form-control" v-model.trim="$v.productdata.price.$model" type="text"
                                    label="Price" placeholder="Enter price" @keypress="onlyNumber" />
                                <div class="error" v-if="submitted && !$v.productdata.price.required">
                                    Please enter price
                                </div>
                            </div>

                            <div class="col-md-4">
                                <label>Discount Price</label>
                                <input class="form-control" v-model.trim="productdata.discountprice" type="text"
                                    label="Discount Price" placeholder="Enter discount price" @keypress="onlyNumber" />
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <label>Quantity<em style="color: red">*</em></label>
                                <input class="form-control" v-model.trim="$v.productdata.quantity.$model" type="text"
                                    label="quantity" placeholder="Enter quantity" @keypress="onlyNumber" />
                                <div class="error" v-if="submitted && !$v.productdata.quantity.required">
                                    Please enter quantity
                                </div>
                            </div>

                            <div class="col-md-4">
                                <label>Image<em style="color: red">*</em></label>
                                <!-- <input class="form-control" type="file" label="Image" ref="productimage"
                                    name="productimage" id="productimage" @change="onFileSelected"
                                    accept="image/x-png,image/gif,image/jpeg" multiple />
                                <div class="error" v-if="submitted && !$v.productdata.productimage.required">Please
                                    select image</div> -->
                                <vue-upload-multiple-image @upload-success="uploadImageSuccess"
                                    @mark-is-primary="markIsPrimary" @before-remove="beforeRemove"
                                    id-upload="myIdUpload" id-edit="myIdEdit" :max-image="20" primary-text="Default"
                                    browse-text="Browse picture(s)" drag-text="Drag pictures"
                                    mark-is-primary-text="Set as default"
                                    popup-text="This image will be displayed as default" :multiple="true"
                                    :show-edit="true" :show-delete="true" :show-add="true">
                                </vue-upload-multiple-image>
                            </div>

                            <div class="col-md-4">
                                <label>Status<em style="color: red">*</em></label>
                                <select class="form-control" v-model.trim="$v.productdata.productstatus.$model">
                                    <option disabled>Select status</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </select>
                                <div class="error" v-if="submitted && !$v.productdata.productstatus.required">
                                    Please select status
                                </div>
                            </div>
                        </div>
                        <br />

                        <!-- Sofa Form -->
                        <div v-if="productdata.categoryid == 3">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Design</label>
                                    <select class="form-control" v-model="attributes.sofadesign">
                                        <option disabled value>Select design</option>
                                        <option v-for="(list, index) in sofadesign" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Size of Sofa</label>
                                    <select class="form-control" v-model="attributes.sofasize">
                                        <option disabled value>Select size of sofa</option>
                                        <option v-for="(list, index) in sofasize" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Fabric</label>
                                    <select class="form-control" v-model="attributes.sofafabric">
                                        <option disabled value>Select fabric</option>
                                        <option v-for="(list, index) in sofafabric" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-4">
                                    <label>Body</label>
                                    <select class="form-control" v-model="attributes.sofabody">
                                        <option disabled value>Select body</option>
                                        <option v-for="(list, index) in sofabody" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Cushion</label>
                                    <select class="form-control" v-model="attributes.sofacushion">
                                        <option disabled value>Select cushion</option>
                                        <option v-for="(list, index) in sofacushion" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Polish</label>
                                    <select class="form-control" v-model="attributes.sofapolish">
                                        <option disabled value>Select polish</option>
                                        <option v-for="(list, index) in sofapolish" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />
                        </div>
                        <!-- Sofa Form -->

                        <!-- Dining Table Form -->
                        <div v-if="productdata.categoryid == 8">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Chair Design</label>
                                    <select class="form-control" v-model="attributes.diningchairdesign">
                                        <option disabled value>Select chair design</option>
                                        <option v-for="(list, index) in diningchairdesign" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Table Design</label>
                                    <select class="form-control" v-model="attributes.diningtabledesign">
                                        <option disabled value>Select tabel design</option>
                                        <option v-for="(list, index) in diningtabledesign" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Nos. of chair</label>
                                    <input class="form-control" type="text" label="Nos of chair"
                                        placeholder="Enter nos. of chair" v-model="attributes.nosofchair" />
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-4">
                                    <label>Size of Table</label>
                                    <select class="form-control" v-model="attributes.diningsizeoftable">
                                        <option disabled value>Select size of table</option>
                                        <option v-for="(list, index) in diningsizeoftable" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Size of Marble/Glass</label>
                                    <select class="form-control" v-model="attributes.diningsizeofmarble">
                                        <option disabled value>Select marble/glass</option>
                                        <option v-for="(list, index) in diningsizeofmarble" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Polish</label>
                                    <select class="form-control" v-model="attributes.diningpolish">
                                        <option disabled value>Select polish</option>
                                        <option v-for="(list, index) in diningpolish" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-4">
                                    <label>Below Glass</label>
                                    <select class="form-control" v-model="attributes.diningbelowglass">
                                        <option disabled value>Select below glass</option>
                                        <option v-for="(list, index) in diningbelowglass" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Fabric</label>
                                    <select class="form-control" v-model="attributes.diningfabric">
                                        <option disabled value>Select fabric</option>
                                        <option v-for="(list, index) in diningfabric" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />
                        </div>
                        <!-- Dining Table Form -->

                        <!-- Center Table Form -->
                        <div v-if="productdata.categoryid == 6">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Center Table Name</label>
                                    <select class="form-control" v-model="attributes.centertablename">
                                        <option disabled value>Select center table name</option>
                                        <option v-for="(list, index) in centertablename" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Size</label>
                                    <select class="form-control" v-model="attributes.tablesize">
                                        <option disabled value>Select size</option>
                                        <option v-for="(list, index) in tablesize" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Polish</label>
                                    <select class="form-control" v-model="attributes.tablepolish">
                                        <option disabled value>Select polish</option>
                                        <option v-for="(list, index) in tablepolish" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-4">
                                    <label>Top</label>
                                    <select class="form-control" v-model="attributes.top">
                                        <option value disabled>Selct top</option>
                                        <option value="marble">Marble</option>
                                        <option value="glass">Glass</option>
                                    </select>
                                </div>

                                <div class="col-md-4" v-if="attributes.top == 'marble'">
                                    <label>Size of Marble</label>
                                    <select class="form-control" v-model="attributes.sizeofmarble">
                                        <option disabled value>Select size of marble</option>
                                        <option v-for="(list, index) in sizeofmarble" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4" v-if="attributes.top == 'glass'">
                                    <label>Size of Glass</label>
                                    <select class="form-control" v-model="attributes.sizeofglass">
                                        <option disabled value>Select size of glass</option>
                                        <option v-for="(list, index) in sizeofglass" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-md-4" v-if="attributes.top == 'glass'">
                                    <label>Below of Glass</label>
                                    <select class="form-control" v-model="attributes.belowofglass">
                                        <option disabled value>Select below of glass</option>
                                        <option v-for="(list, index) in belowofglass" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />
                        </div>
                        <!-- Center Table Form -->

                        <!-- Bed Room Form -->
                        <div v-if="productdata.categoryid == 7">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Design</label>
                                    <select class="form-control" v-model="attributes.beddesign">
                                        <option disabled value>Select design</option>
                                        <option v-for="(list, index) in beddesign" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-3">
                                    <label>Double bed Mattress Size</label>
                                    <select class="form-control" v-model="attributes.doublebedmattresssize">
                                        <option disabled value>
                                            Select double bed mattress size
                                        </option>
                                        <option v-for="(list, index) in doublebedmattresssize"
                                            :value="list.Attribute_id" :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Types of Material</label>
                                    <select class="form-control" v-model="attributes.doublebedmaterial">
                                        <option disabled value>Select types of material</option>
                                        <option v-for="(list, index) in doublebedmaterial" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Colour</label>
                                    <select class="form-control" v-model="attributes.doublebedmattresscolor">
                                        <option disabled value>Select colour</option>
                                        <option value="other">Other</option>
                                        <option v-for="(list, index) in doublebedcolour" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <div v-if="doublebedmattresscolor == 'other'">
                                        <label>Colour</label>
                                        <input class="form-control" type="text" label="Colour"
                                            placeholder="Enter colour"
                                            v-model="attributes.doublebedmattresscolorcode" />
                                    </div>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-3">
                                    <label>Wardrobe Size</label>
                                    <select class="form-control" v-model="attributes.wardrobesize">
                                        <option disabled value>Select wardrobe size</option>
                                        <option v-for="(list, index) in wardrobesize" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Types of Material</label>
                                    <select class="form-control" v-model="attributes.wardrobematerial">
                                        <option disabled value>Select types of material</option>
                                        <option v-for="(list, index) in wardrobematerial" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Colour</label>
                                    <select class="form-control" v-model="attributes.wardrobecolor">
                                        <option disabled value>Select colour</option>
                                        <option value="other">Other</option>
                                        <option v-for="(list, index) in wardrobecolour" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <div v-if="attributes.wardrobecolor == 'other'">
                                        <label>Colour</label>
                                        <input class="form-control" type="text" label="Colour"
                                            placeholder="Enter colour" v-model="attributes.wardrobecolorcode" />
                                    </div>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-3">
                                    <label>Dressing Table Size</label>
                                    <select class="form-control" v-model="attributes.dressingtablesize">
                                        <option disabled value>Select dressing table size</option>
                                        <option v-for="(list, index) in dressingtablesize" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Types of Material</label>
                                    <select class="form-control" v-model="attributes.dressingmaterial">
                                        <option disabled value>Select types of material</option>
                                        <option v-for="(list, index) in dressingmaterial" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Colour</label>
                                    <select class="form-control" v-model="attributes.dressingtablecolor">
                                        <option disabled value>Select colour</option>
                                        <option value="other">Other</option>
                                        <option v-for="(list, index) in dressingcolour" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <div v-if="attributes.dressingtablecolor == 'other'">
                                        <label>Colour</label>
                                        <input class="form-control" type="text" label="Colour"
                                            placeholder="Enter colour" v-model="attributes.dressingtablecolorcode" />
                                    </div>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-3">
                                    <label>Side Table Size</label>
                                    <select class="form-control" v-model="attributes.sidetablesize">
                                        <option disabled value>Select side table size</option>
                                        <option v-for="(list, index) in sidetablesize" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Types of Material</label>
                                    <select class="form-control" v-model="attributes.sidetablematerial">
                                        <option disabled value>Select types of material</option>
                                        <option v-for="(list, index) in sidetablematerial" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Colour</label>
                                    <select class="form-control" v-model="attributes.sidetablecolor">
                                        <option disabled value>Select colour</option>
                                        <option value="other">Other</option>
                                        <option v-for="(list, index) in sidetablecolour" :value="list.Attribute_id"
                                            :key="index">
                                            {{ list.value }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <div v-if="attributes.sidetablecolor == 'other'">
                                        <label>Colour</label>
                                        <input class="form-control" type="text" label="Colour"
                                            placeholder="Enter colour" v-model="attributes.sidetablecolorcode" />
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>

                        <!-- Bed Room Form -->

                        <div>
                            <input type="checkbox" name="onsale" id="onsale" :true-value="1" :false-value="0"
                                v-model="productdata.onsale" />
                            ON SALE&nbsp;
                            <input type="checkbox" name="featured" id="featured" :true-value="1" :false-value="0"
                                v-model="productdata.featured" />
                            FEATURED&nbsp;
                            <input type="checkbox" name="newarrival" id="newarrival" :true-value="1" :false-value="0"
                                v-model="productdata.newarrival" />
                            NEW ARRIVAL&nbsp;
                            <input type="checkbox" name="bestsellers" id="bestsellers" :true-value="1" :false-value="0"
                                v-model="productdata.bestsellers" />
                            BEST SELLERS&nbsp;
                        </div>
                        <div class="text">
                            <button type="submit" class="btn btn-secondary dashboard">
                                Add Product</button>&nbsp;
                            <router-link to="/admin/dashboard/product"><button type="button"
                                    class="btn btn-secondary dashboard">
                                    Cancel
                                </button></router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <content-footer></content-footer>
    </div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import {
    required,
    minLength,
    maxLength,
    between,
    number,
    file_size_validation,
    alpha,
} from "vuelidate/lib/validators";
import {
    exit
} from "process";
export default {
    name: "addProduct",
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
        VueUploadMultipleImage,
    },

    data() {
        return {
            editor: ClassicEditor,
            submitted: false,
            top: "",
            doublebedmattresscolor: [],
            wardrobecolor: [],
            dressingtablecolor: [],
            sidetablecolor: [],
            category: [],
            subcategory: [],
            sofadesign: [],
            sofasize: [],
            sofafabric: [],
            sofabody: [],
            sofacushion: [],
            sofapolish: [],
            centertablename: [],
            tablesize: [],
            tablepolish: [],
            tabletop: [],
            sizeofmarble: [],
            sizeofglass: [],
            belowofglass: [],
            beddesign: [],
            doublebedmattresssize: [],
            doublebedmaterial: [],
            doublebedcolour: [],
            wardrobesize: [],
            wardrobematerial: [],
            wardrobecolour: [],
            dressingtablesize: [],
            dressingmaterial: [],
            dressingcolour: [],
            sidetablesize: [],
            sidetablematerial: [],
            sidetablecolour: [],
            diningchairdesign: [],
            diningtabledesign: [],
            diningsizeoftable: [],
            diningsizeofmarble: [],
            diningpolish: [],
            diningbelowglass: [],
            diningfabric: [],

            productdata: {
                categoryid: "",
                subcategoryid: "",
                productname: "",
                sku: "",
                price: "",
                quantity: "",
                productdescription: "",
                shortproductdescription: "",
                productimage: [],
                productstatus: "1",
                onsale: "",
                featured: "",
                newarrival: "",
                bestsellers: "",
                discountprice: "",
            },

            attributes: {
                nosofchair: "",
                doublebedmattresscolor: "",
                wardrobecolor: "",
                dressingtablecolor: "",
                sidetablecolor: "",
                doublebedmattresscolorcode: "",
                wardrobecolorcode: "",
                dressingtablecolorcode: "",
                sidetablecolorcode: "",
                top: "",
                sofadesign: "",
                sofasize: "",
                sofafabric: "",
                sofabody: "",
                sofacushion: "",
                sofapolish: "",
                centertablename: "",
                tablesize: "",
                tablepolish: "",
                tabletop: "",
                sizeofmarble: "",
                sizeofglass: "",
                belowofglass: "",
                beddesign: "",
                doublebedmattresssize: "",
                doublebedmaterial: "",
                doublebedcolour: "",
                wardrobesize: "",
                wardrobematerial: "",
                wardrobecolour: "",
                dressingtablesize: "",
                dressingmaterial: "",
                dressingcolour: "",
                sidetablesize: "",
                sidetablematerial: "",
                sidetablecolour: "",
                diningchairdesign: "",
                diningtabledesign: "",
                diningsizeoftable: "",
                diningsizeofmarble: "",
                diningpolish: "",
                diningbelowglass: "",
                diningfabric: "",
            },
        };
    },

    validations: {
        productdata: {
            categoryid: {
                required,
            },
            subcategoryid: {
                required,
            },
            productname: {
                required,
            },
            sku: {
                required,
            },
            price: {
                required,
            },
            quantity: {
                required,
            },
            productdescription: {
                required,
            },
            shortproductdescription: {
                required,
            },
            productimage: {
                required,
            },
            productstatus: {
                required,
            },
        },
    },

    methods: {
        uploadImageSuccess(formData, index, fileList) {
            this.productdata.productimage = formData;
            // console.log('data', formData, index, fileList)
            // Upload image api
            // axios.post('http://your-url-upload', formData).then(response => {
            //   console.log(response)
            // })
        },
        beforeRemove(index, removeCallBack) {
            removeCallBack();
        },

        markIsPrimary(index, fileList) {
            console.log("markIsPrimary data", index, fileList);
        },

        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault();
            }
        },

        onFileSelected(event) {
            this.productdata.productimage = event.target.files;
        },

        submit() {
            let formData = new FormData();
            formData.append("categoryid", this.productdata.categoryid);
            formData.append("subcategoryid", this.productdata.subcategoryid);
            formData.append("productname", this.productdata.productname);
            formData.append("sku", this.productdata.sku);
            formData.append("price", this.productdata.price);
            formData.append("quantity", this.productdata.quantity);
            formData.append(
                "productdescription",
                this.productdata.productdescription
            );
            formData.append("productstatus", this.productdata.productstatus);
            formData.append("onsale", this.productdata.onsale);
            formData.append("featured", this.productdata.featured);
            formData.append("newarrival", this.productdata.newarrival);
            formData.append("bestsellers", this.productdata.bestsellers);
            formData.append("discountprice", this.productdata.discountprice);
            formData.append(
                "shortproductdescription",
                this.productdata.shortproductdescription
            );
            formData.append("nosofchair", this.attributes.nosofchair);
            formData.append(
                "doublebedmattresscolor",
                this.attributes.doublebedmattresscolor
            );
            formData.append("wardrobecolor", this.attributes.wardrobecolor);
            formData.append("dressingtablecolor", this.attributes.dressingtablecolor);
            formData.append("sidetablecolor", this.attributes.sidetablecolor);
            formData.append(
                "doublebedmattresscolorcode",
                this.attributes.doublebedmattresscolorcode
            );
            formData.append("wardrobecolorcode", this.attributes.wardrobecolorcode);
            formData.append(
                "dressingtablecolorcode",
                this.attributes.dressingtablecolorcode
            );
            formData.append("sidetablecolorcode", this.attributes.sidetablecolorcode);
            formData.append("top", this.attributes.top);
            formData.append("sofadesign", this.attributes.sofadesign);
            formData.append("sofasize", this.attributes.sofasize);
            formData.append("sofabody", this.attributes.sofabody);
            formData.append("sofacushion", this.attributes.sofacushion);
            formData.append("centertablename", this.attributes.centertablename);
            formData.append("tablesize", this.attributes.tablesize);
            formData.append("tablepolish", this.attributes.tablepolish);
            formData.append("tabletop", this.attributes.tabletop);
            formData.append("sizeofmarble", this.attributes.sizeofmarble);
            formData.append("sizeofglass", this.attributes.sizeofglass);
            formData.append("belowofglass", this.attributes.belowofglass);
            formData.append(
                "doublebedmattresssize",
                this.attributes.doublebedmattresssize
            );
            formData.append("doublebedmaterial", this.attributes.doublebedmaterial);
            formData.append("doublebedcolour", this.attributes.doublebedcolour);
            formData.append("wardrobesize", this.attributes.wardrobesize);
            formData.append("wardrobematerial", this.attributes.wardrobematerial);
            formData.append("wardrobecolour", this.attributes.wardrobecolour);
            formData.append("dressingtablesize", this.attributes.dressingtablesize);
            formData.append("dressingmaterial", this.attributes.dressingmaterial);
            formData.append("dressingcolour", this.attributes.dressingcolour);
            formData.append("sidetablesize", this.attributes.sidetablesize);
            formData.append("sidetablematerial", this.attributes.sidetablematerial);
            formData.append("sidetablecolour", this.attributes.sidetablecolour);
            formData.append("diningchairdesign", this.attributes.diningchairdesign);
            formData.append("diningtabledesign", this.attributes.diningtabledesign);
            formData.append("diningsizeoftable", this.attributes.diningsizeoftable);
            formData.append("diningsizeofmarble", this.attributes.diningsizeofmarble);
            formData.append("diningbelowglass", this.attributes.diningbelowglass);
            formData.append("diningpolish", this.attributes.diningpolish);
            formData.append("diningfabric", this.attributes.diningfabric);

            for (var i = 0; i < this.$refs.productimage.files.length; i++) {
                let file = this.$refs.productimage.files[i];
                formData.append("productimage[" + i + "]", file);
            }
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                this.axios
                    .post(
                        `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addproduct`,
                        formData
                    )
                    .then(({
                        data
                    }) => {
                        this.$router.push("/admin/dashboard/product");
                        this.flashMessage.success({
                            message: "Product Added Successfully",
                        });
                    })
                    .catch((error) => {
                        // console.log(error);
                        if (error.response.data.errors.sku) {
                            this.flashMessage.error({
                                message: error.response.data.errors.sku[0],
                            });
                        }
                    });
            }
        },
    },
    watch: {
        "productdata.categoryid": function (value) {
            this.axios
                .get(
                    `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivesubcategory/` +
                    this.productdata.categoryid
                )
                .then((subcategory) => {
                    this.subcategory = subcategory.data;
                });

            this.axios
                .get(
                    `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getadditionalattributes/` +
                    value
                )
                .then((res) => {
                    var sofadesign = new Array();
                    var sofasize = new Array();
                    var sofafabric = new Array();
                    var sofabody = new Array();
                    var sofacushion = new Array();
                    var sofapolish = new Array();
                    var centertablename = new Array();
                    var tablesize = new Array();
                    var tablepolish = new Array();
                    var tabletop = new Array();
                    var sizeofmarble = new Array();
                    var sizeofglass = new Array();
                    var belowofglass = new Array();
                    var beddesign = new Array();
                    var doublebedmattresssize = new Array();
                    var doublebedmaterial = new Array();
                    var doublebedcolour = new Array();
                    var wardrobesize = new Array();
                    var wardrobematerial = new Array();
                    var wardrobecolour = new Array();
                    var dressingtablesize = new Array();
                    var dressingmaterial = new Array();
                    var dressingcolour = new Array();
                    var sidetablesize = new Array();
                    var sidetablematerial = new Array();
                    var sidetablecolour = new Array();
                    var diningchairdesign = new Array();
                    var diningtabledesign = new Array();
                    var diningsizeoftable = new Array();
                    var diningsizeofmarble = new Array();
                    var diningpolish = new Array();
                    var diningbelowglass = new Array();
                    var diningfabric = new Array();

                    var a = 0,
                        b = 0,
                        c = 0,
                        d = 0,
                        e = 0,
                        f = 0,
                        g = 0,
                        h = 0,
                        i = 0,
                        j = 0,
                        k = 0,
                        l = 0,
                        m = 0,
                        n = 0,
                        o = 0,
                        p = 0,
                        q = 0,
                        r = 0,
                        s = 0,
                        t = 0,
                        u = 0,
                        v = 0,
                        w = 0,
                        x = 0,
                        y = 0,
                        z = 0,
                        aa = 0,
                        bb = 0,
                        cc = 0,
                        dd = 0,
                        ee = 0,
                        ff = 0,
                        gg = 0;

                    res.data.forEach((obj, idx) => {
                        if (obj.name === "Sofa Design") {
                            sofadesign[a] = obj;
                            a++;
                        }
                        if (obj.name === "Size") {
                            sofasize[b] = obj;
                            b++;
                        }
                        if (obj.name === "Fabric") {
                            sofafabric[c] = obj;
                            c++;
                        }
                        if (obj.name === "Body") {
                            sofabody[d] = obj;
                            d++;
                        }
                        if (obj.name === "Cushion") {
                            sofacushion[e] = obj;
                            e++;
                        }
                        if (obj.name === "Polish") {
                            sofapolish[f] = obj;
                            f++;
                        }
                        if (obj.name === "Name") {
                            centertablename[g] = obj;
                            g++;
                        }
                        if (obj.name === "Size of Table") {
                            tablesize[h] = obj;
                            h++;
                        }
                        if (obj.name === "Polish") {
                            tablepolish[i] = obj;
                            i++;
                        }
                        if (obj.name === "Table Top") {
                            tabletop[j] = obj;
                            j++;
                        }
                        if (obj.name === "Size of Marble") {
                            sizeofmarble[k] = obj;
                            k++;
                        }
                        if (obj.name === "Size of Top") {
                            sizeofglass[l] = obj;
                            l++;
                        }
                        if (obj.name === "Below Glass") {
                            belowofglass[m] = obj;
                            m++;
                        }
                        if (obj.name === "Design") {
                            beddesign[n] = obj;
                            n++;
                        }
                        if (obj.name === "Bed Mattress Size") {
                            doublebedmattresssize[o] = obj;
                            o++;
                        }
                        if (obj.name === "Type of Material") {
                            doublebedmaterial[p] = obj;
                            p++;
                        }
                        if (obj.name === "Color/Polish") {
                            doublebedcolour[q] = obj;
                            q++;
                        }

                        if (obj.name === "Wardrobe Size") {
                            wardrobesize[r] = obj;
                            r++;
                        }
                        if (obj.name === "Wardrobe Material") {
                            wardrobematerial[s] = obj;
                            s++;
                        }
                        if (obj.name === "Wardrobe Color/Polish") {
                            wardrobecolour[t] = obj;
                            t++;
                        }

                        if (obj.name === "Dressing Table Size") {
                            dressingtablesize[u] = obj;
                            u++;
                        }
                        if (obj.name === "Dressing Table Material") {
                            dressingmaterial[v] = obj;
                            v++;
                        }
                        if (obj.name === "Dressing Table Color/Polish") {
                            dressingcolour[w] = obj;
                            w++;
                        }

                        if (obj.name === "Side Table Size") {
                            sidetablesize[x] = obj;
                            x++;
                        }
                        if (obj.name === "Side Table Material") {
                            sidetablematerial[y] = obj;
                            y++;
                        }
                        if (obj.name === "Side Table Color/Polish") {
                            sidetablecolour[z] = obj;
                            z++;
                        }
                        if (obj.name === "Chair Design") {
                            diningchairdesign[aa] = obj;
                            aa++;
                        }
                        if (obj.name === "Table Design") {
                            diningtabledesign[bb] = obj;
                            bb++;
                        }
                        if (obj.name === "Size of Table") {
                            diningsizeoftable[cc] = obj;
                            cc++;
                        }
                        if (obj.name === "Size of Marble") {
                            diningsizeofmarble[dd] = obj;
                            dd++;
                        }
                        if (obj.name === "Polish") {
                            diningpolish[ee] = obj;
                            ee++;
                        }
                        if (obj.name === "Below Glass") {
                            diningbelowglass[ff] = obj;
                            ff++;
                        }
                        if (obj.name === "Fabric") {
                            diningfabric[gg] = obj;
                            gg++;
                        }
                    });

                    this.sofadesign = sofadesign;
                    this.sofasize = sofasize;
                    this.sofafabric = sofafabric;
                    this.sofabody = sofabody;
                    this.sofacushion = sofacushion;
                    this.sofapolish = sofapolish;
                    this.centertablename = centertablename;
                    this.tablesize = tablesize;
                    this.tablepolish = tablepolish;
                    this.tabletop = tabletop;
                    this.sizeofmarble = sizeofmarble;
                    this.sizeofglass = sizeofglass;
                    this.belowofglass = belowofglass;
                    this.beddesign = beddesign;
                    this.doublebedmattresssize = doublebedmattresssize;
                    this.doublebedmaterial = doublebedmaterial;
                    this.doublebedcolour = doublebedcolour;
                    this.wardrobesize = wardrobesize;
                    this.wardrobematerial = wardrobematerial;
                    this.wardrobecolour = wardrobecolour;
                    this.dressingtablesize = dressingtablesize;
                    this.dressingmaterial = dressingmaterial;
                    this.dressingcolour = dressingcolour;
                    this.sidetablesize = sidetablesize;
                    this.sidetablematerial = sidetablematerial;
                    this.sidetablecolour = sidetablecolour;
                    this.diningchairdesign = diningchairdesign;
                    this.diningtabledesign = diningtabledesign;
                    this.diningsizeoftable = diningsizeoftable;
                    this.diningsizeofmarble = diningsizeofmarble;
                    this.diningpolish = diningpolish;
                    this.diningbelowglass = diningbelowglass;
                    this.diningfabric = diningfabric;
                });
        },
    },

    mounted() {
        this.axios
            .get(
                `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivecategory`
            )
            .then((category) => {
                this.category = category.data;
            });
    },
};
</script>

<style lang="scss">
.image-container {
    width: 377px !important;
}
</style>
